import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "../components/common";
import { api } from "../lib/api";
import { Seo, breadcrumbs } from "../components/Seo";

export default function KnowledgeHub() {
  const [posts, setPosts] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);
  const cats = ["All", ...new Set(posts.map((p) => p.category))];
  const shown = filter === "All" ? posts : posts.filter((p) => p.category === filter);

  return (
    <div data-testid="knowledge-hub-page" className="pt-32">
      <Seo title="Knowledge Hub" path="/knowledge-hub" description="Guides and insights on UK commercial finance from DNA Finance: asset finance, development finance, invoice finance, commercial mortgages, bridging and business growth funding." jsonLd={breadcrumbs([{ name: "Home", path: "/" }, { name: "Knowledge Hub", path: "/knowledge-hub" }])} />
      <section className="container-x mx-auto max-w-[1400px] py-16">
        <Reveal className="max-w-2xl mb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-lime mb-4">Knowledge Hub</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter">Commercial finance insight & guides</h1>
          <p className="text-grey text-lg mt-6 leading-relaxed">Funding news, sector guides and practical advice from the DNA Finance team.</p>
        </Reveal>

        <div className="flex flex-wrap gap-2 mb-12">
          {cats.map((c) => (
            <button key={c} data-testid={`blog-filter-${c.toLowerCase().replace(/\s/g, "-")}`} onClick={() => setFilter(c)} className={`px-5 py-2 text-sm border transition-colors ${filter === c ? "bg-lime text-[#1A1A1A] border-lime font-bold" : "border-[#808080]/30 text-grey hover:border-lime hover:text-lime"}`}>{c}</button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {shown.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.08}>
              <Link to={`/knowledge-hub/${p.slug}`} data-testid={`hub-card-${p.slug}`} className="group block border border-[#808080]/20 hover:border-lime/40 transition-colors h-full">
                <div className="h-52 overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" />
                </div>
                <div className="p-6">
                  <span className="text-xs uppercase tracking-widest text-lime">{p.category}</span>
                  <h3 className="text-xl font-bold mt-3 group-hover:text-lime transition-colors leading-snug">{p.title}</h3>
                  <p className="text-grey text-sm mt-3 line-clamp-2">{p.excerpt}</p>
                  <p className="text-xs text-grey mt-4">{p.read_time}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
